export default __webpack_public_path__ + "static/media/photo-camille.1edfb984.jpeg";